import clamp from 'lodash/clamp'
import includes from 'lodash/includes'

export const getErrorMessageByErrorCode = (errorCode: string | null) => {
  if (!errorCode) {
    return somethingWrong
  }
  return errorMap[errorCode] || somethingWrong
}

export const getMaxFilesByUploadedImages = (uploadedImagesCount: number) =>
  clamp(Math.abs(uploadedImagesCount - IMAGES_COUNT_LIMIT), 0, IMAGES_COUNT_LIMIT)

export const isErrorCodeExist = (val: string | null): boolean =>
  includes(Object.keys(errorMap), val)

// 5 MB
export const MAX_SIZE = 5000000

const IMAGES_COUNT_LIMIT = 10

const somethingWrong = 'Something is wrong with the file'

export enum CustomErrorCodes {
  AlreadyExistsFile = 'already-exists',
  FileInvalidType = 'file-invalid-type',
  FileTooLarge = 'file-too-large',
  FileTooSmall = 'file-too-small',
}

type ErrorMap = {
  [key: string]: string
}

const errorMap: ErrorMap = {
  [CustomErrorCodes.FileInvalidType]: 'Unsupported File Type',
  [CustomErrorCodes.FileTooLarge]: 'File Exceeds Size Limit',
  [CustomErrorCodes.FileTooSmall]: 'File Exceeds Size Limit',
}
